import type { Page } from "@infinitaslearning/module-data-analyticstracker"
import { useEffect } from "react"
import { AnalyticsPageCategory, AnalyticsPageType } from "./../models/types"
import { useFullBrandName } from "./useFullBrandName"
import { useTracker } from "./useTracker"

export function usePageTracking(category: AnalyticsPageCategory, type: AnalyticsPageType, id?: string): void {
  const tracker = useTracker()
  const brand: string = useFullBrandName()
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    tracker.page(getPage(category, type, brand, id))
  }, [])
}

export function useIndexTracking(chapterId?: string, regionId?: string, themeId?: string): void {
  const brand: string = useFullBrandName()
  const tracker = useTracker()
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    const pageType: AnalyticsPageType = chapterId
      ? AnalyticsPageType.Chapter
      : regionId
        ? AnalyticsPageType.Region
        : themeId
          ? AnalyticsPageType.Theme
          : AnalyticsPageType.Overview
    const id: string | undefined = chapterId ? chapterId : regionId ? regionId : themeId ? themeId : undefined
    tracker.page(getPage(AnalyticsPageCategory.ContentLibrary, pageType, brand, id))
  }, [chapterId, regionId, themeId])
}

export function useAtlasTracking(mapId?: string, projectId?: string): void {
  const brandName: string = useFullBrandName()
  const tracker = useTracker()
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    if (mapId || projectId) {
      const pageType: AnalyticsPageType = mapId ? AnalyticsPageType.Map : AnalyticsPageType.Project
      const id: string | undefined = mapId ? mapId : projectId ? projectId : undefined
      tracker.page(getPage(AnalyticsPageCategory.Content, pageType, brandName, id))
    }
  }, [mapId, projectId])
}

function getPage(category: AnalyticsPageCategory, type: AnalyticsPageType, brandName: string, id?: string): Page {
  return {
    category,
    type,
    id,
    brand: {
      name: brandName
    }
  }
}
